'use client';

import { Toaster as SonnerToaster, toast } from 'sonner';
import type { ComponentProps } from 'react';

export type ToasterProps = ComponentProps<typeof SonnerToaster>;

export function Toaster(props: ToasterProps) {
  return (
    <SonnerToaster
      position="bottom-right"
      duration={4000}
      visibleToasts={3}
      closeButton
      richColors
      toastOptions={{
        style: {
          fontFamily: 'var(--font-sans)',
        },
      }}
      {...props}
    />
  );
}

export { toast };
